// extracted by mini-css-extract-plugin
export default {"root":"MainPanelHeader_root__ef2Wn","title":"MainPanelHeader_title__Un4+y"};